import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_b5dlwpia46: FaireBrandEntity = {
  token: "b_b5dlwpia46",
  type: "brand",
  name: "Coco Clem",
  avatarUrl:
    "https://cdn.faire.com/fastly/f971b07168fd960b7a0612ac280b556ef5fd27ea0d1344e94b3a0abc0a6ce466.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/f86ef539cab2e17d6ea767f4457d374adcc4da56246be0c60648d288df77afe0.png",
  logoUrl:
    "https://cdn.faire.com/fastly/f971b07168fd960b7a0612ac280b556ef5fd27ea0d1344e94b3a0abc0a6ce466.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f86ef539cab2e17d6ea767f4457d374adcc4da56246be0c60648d288df77afe0.png",
  location: "Wilmington, NC, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 4,
  isInsider: true,
  description:
    "Small objects, made strange.\n\nAt Coco Clem, we transform overlooked tools, childhood leftovers, and sentimental scraps into tiny, wearable sculptures. Our jewelry blends playfulness with intentional design, turning the familiar into something collectible and new.\n\nFounded in 2018 by artist Courtney Rivenbark, Coco Clem began in a 100-square-foot bedroom and has since grown into a line of joyful, nostalgia-inspired jewelry and apparel loved by customers worldwide.\n\nKnown for viral, patent-pending designs like the Mini Claw Clip Hoop Earrings and Scissor Earrings, Coco Clem reimagines everyday objects as wearable art. Each piece is produced responsibly in small batches with trusted partners, including a manufacturer certified by the Responsible Jewellery Council for ethical, environmental, and labor standards.\n\nAt its core, Coco Clem mixes curiosity, joy, and intentional design, bringing playful objects to life with meaning and care. I hope you find something you love! ",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:08.156Z",
    importedBy: "entity-db-cli",
  },
};
